import { Box, Button, IconButton, Paper, Typography } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BorderLinearProgress } from '../../../../components/ui/linerProgress';
import { resetMyGarageSlice, setActiveStep } from '../../../../toolkit/myGarage/myGarageSlice';
import { MyGarageSteps } from '../../../../utils/constants/myGarage';
import { SellMyCarSteps } from '../../../../utils/constants/sellMyCar';
import Gallery from './Gallery';
import { GeneralInfo } from './GeneralInfo';
import Questionnaire from './Questionnaire';
import Specifications from './Specifications';
import { useTranslation } from 'react-i18next';
import { ArrowBack } from '@mui/icons-material';
import theme from '../../../../theme';

const SellMyCar = ({ changeTabHandler, onSuccessCallback }) => {
  // useDispatch...
  const dispatch = useDispatch();
  // useDispatch...

  // custom hook calls start...
  const { t } = useTranslation('sellMyCar');
  // custom hook calls end...

  const { activeStep } = useSelector((state) => state.myGarage);
  const activeIndex = SellMyCarSteps.map((step) => step.value).findIndex((step) => activeStep.value === step);

  // useState variables start...
  const [isFormDataSet, setIsFormDataSet] = React.useState(false);
  // useState variables end...

  const getSellCarScreen = (activeStep, previousFormHandler) => {
    switch (activeStep?.value) {
      case 'generalInfo':
        return <GeneralInfo previousFormHandler={previousFormHandler} />;
      // return <Gallery
      //   onSuccessCallback={onSuccessCallback}
      // />;
      case 'questionare':
        return <Questionnaire previousFormHandler={previousFormHandler} />;
      case 'specifications':
        return <Specifications previousFormHandler={previousFormHandler} />;
      case 'gallery':
        return <Gallery onSuccessCallback={onSuccessCallback} previousFormHandler={previousFormHandler} changeTabHandler={changeTabHandler} />;
      default:
        return null;
    }
  };

  const previousFormHandler = () => {
    const currentPageIdx = MyGarageSteps?.findIndex((item) => {
      return item?.value === activeStep?.value;
    });

    if (currentPageIdx > 0) {
      dispatch(setActiveStep(MyGarageSteps[currentPageIdx - 1]));
    } else {
      changeTabHandler();
    }
  };

  // useEffect start...
  React.useEffect(() => {
    return () => {
      dispatch(resetMyGarageSlice());
    };
  }, []);
  // useEffect end...

  return (
    <Box
      sx={{
        position: 'relative',
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        background: 'white',
        borderRadius: 6,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          // height: '100%',
          padding: '1rem',
          borderRadius: '24px',
        }}
      >
        <Box display={'flex'} flexDirection={'column'}>
          <Box
            display={'flex'}
            height={'84px'}
            justifyContent={'space-between'}
            alignItems={'center'}
            sx={{ background: '#FAFAFA', p: '0 30px 0 0' }}
          >
            <Box display={'flex'} alignItems={'center'} gap={0}>
              <IconButton onClick={changeTabHandler}>
                <ArrowBack />
              </IconButton>
              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{
                  fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                  fontWeight: 600,
                  textWrap: 'nowrap',
                }}
              >
                {/* {activeStep?.label} */}
                {t(activeStep?.label)}
              </Typography>
            </Box>
            <Typography color={'text.primary'} sx={{textWrap:'nowrap'}}>
              <Typography component={'span'} color={'text.primary'}>
                ({SellMyCarSteps.length - (activeIndex + 1)} {t('steps left')}){' '}
              </Typography>
              {((activeIndex + 1) / SellMyCarSteps.length) * 100}%
            </Typography>
          </Box>
          <Box>
            <BorderLinearProgress
              width={'100%'}
              variant="determinate"
              value={((activeIndex + 1) / SellMyCarSteps.length) * 100}
            />
          </Box>
          {getSellCarScreen(activeStep, previousFormHandler)}
        </Box>
      </Paper>
    </Box>
  );
};

export default SellMyCar;
